module.exports = __webpack_public_path__ + "img/GAME_SWEEPLEAVES.53bb388a.png";